/* tslint:disable */
/* eslint-disable */
/**
 * FanFair Complete API
 * Complete API documentation for FanFair platform including both public and private endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { PayerResponse } from '../models';
/**
 * PayersApi - axios parameter creator
 * @export
 */
export const PayersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Find the calling partner\'s payer by email
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findPayerByEmail: async (email: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('findPayerByEmail', 'email', email)
            const localVarPath = `/api/v1/payers/by-email/{email}`
                .replace(`{${"email"}}`, encodeURIComponent(String(email)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetch a payer scoped to the calling partner
         * @param {string} payerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayer: async (payerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'payerId' is not null or undefined
            assertParamExists('getPayer', 'payerId', payerId)
            const localVarPath = `/api/v1/payers/{payerId}`
                .replace(`{${"payerId"}}`, encodeURIComponent(String(payerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PayersApi - functional programming interface
 * @export
 */
export const PayersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PayersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Find the calling partner\'s payer by email
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findPayerByEmail(email: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PayerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findPayerByEmail(email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayersApi.findPayerByEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Fetch a payer scoped to the calling partner
         * @param {string} payerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPayer(payerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PayerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPayer(payerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayersApi.getPayer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PayersApi - factory interface
 * @export
 */
export const PayersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PayersApiFp(configuration)
    return {
        /**
         * 
         * @summary Find the calling partner\'s payer by email
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findPayerByEmail(email: string, options?: RawAxiosRequestConfig): AxiosPromise<PayerResponse> {
            return localVarFp.findPayerByEmail(email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Fetch a payer scoped to the calling partner
         * @param {string} payerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayer(payerId: string, options?: RawAxiosRequestConfig): AxiosPromise<PayerResponse> {
            return localVarFp.getPayer(payerId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PayersApi - object-oriented interface
 * @export
 * @class PayersApi
 * @extends {BaseAPI}
 */
export class PayersApi extends BaseAPI {
    /**
     * 
     * @summary Find the calling partner\'s payer by email
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayersApi
     */
    public findPayerByEmail(email: string, options?: RawAxiosRequestConfig) {
        return PayersApiFp(this.configuration).findPayerByEmail(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Fetch a payer scoped to the calling partner
     * @param {string} payerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayersApi
     */
    public getPayer(payerId: string, options?: RawAxiosRequestConfig) {
        return PayersApiFp(this.configuration).getPayer(payerId, options).then((request) => request(this.axios, this.basePath));
    }
}

